import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import Money from "../Common/Money";
import {getSession} from "../../services/Session/reducer";
import {OrderType} from "../../services/Api/types";


interface OwnProps {
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const CartSubmitInfoComponent = (props: Props) => {
    const {t} = useTranslation();

    const renderDeliverInfo = () => {
        if (props.session.order_type === OrderType.DELIVERY) return undefined;

        if (!props.session?.default_min_order_price_money || !props.session?.default_min_order_price_money?.amount) return undefined;

        return (
            <p className='mb-0'>
                {t("common.word.min_order_price")}: <strong><Money
                value={props.session?.default_min_order_price_money}/></strong>
            </p>
        )
    }

    const minPrice = renderDeliverInfo();

    return (
        <div className={"cart-submit-info-after"}>
            {minPrice && (
                <div className={"text-center mt-3"}>
                    {minPrice}
                </div>
            )}
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartSubmitInfoComponent));
